import React from "react";

import imageOne from "../../resource/dana/gilanpasa/gilanpasa-afternoon/1.png";
import imageThree from "../../resource/dana/gilanpasa/gilanpasa-afternoon/2.png";
import imageFour from "../../resource/dana/gilanpasa/gilanpasa-afternoon/photo.jpeg";
import TitleChnage from '../../Hook/TitleChnage'
const AfternoonGilapasa = () => {
  TitleChnage("Afternoon Gilanpasa page")
  return (
    <div className="instructions-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="mt-4 dark-gold font-main p-4">Evening Allowables</h1>

      <div className="p-4 mt-5">
        <h3 className="h4 mt-5">
          According to the Vinaya Pitaka, the Buddha established guidelines for
          the types of food and drinks permitted after noon. The following items
          are allowed:
        </h3>

        <p className="h4 mt-6 ">
          <span className="dark-gold text-bold">&#x2022; Fruit Juices:</span>{" "}
          All fruit juices are permitted after noon, including those made from
          small to medium-sized fruits like mango, apple, banana, grapes, lime,
          orange, pomegranate, avocado, tangerine, guava, and various berries.
        </p>
        <ul className="mt-5 list-0 h4">
          <li className="mt-5">
            Important Rule: Larger fruits such as papaya, melons, pineapple, and
            ripe jackfruit, as well as coconut water, are not permitted after
            noon. This additional rule is based on the interpretations of the
            Vinaya Pitaka by great teachers (Atta Katha) and is followed by all
            branches of the Sri Kalyana Yogashrama Sansthawa.
          </li>
          <li className="mt-5">
            Juicing Guidelines: Fruit juices must be made only from the fruits
            mentioned above. Grains or vegetables should not be mixed with fruit
            juice, and the juice should not be boiled. It should be strained to
            ensure no solid pieces remain.
          </li>
        </ul>

        <p className="h4 mt-6 ">
          <span className="dark-gold text-bold">
            &#x2022; Herbal Medicinal Drinks:
          </span>{" "}
          Herbal drinks derived from dried or fresh flowers, leaves, and seeds
          are allowed in the evening. Some examples include:
        </p>
        <ul className="mt-5 list-0 h4">
          <li className="mt-5">
            Permissible Herbal Drinks: Juices made from fresh or dried herbs
            such as Gotu Kola, Mukunuwanna leaves, Coriander leaves, Curry
            leaves, and drinks like boiled Coriander seeds, tea, coffee,
            Iramusu, Ranawara, dried Beli flowers(belli mal), Venival Gata,
            Nelli, Rasakida, Ginger, Dates, Curry leaves, etc.
          </li>
          <li className="mt-5">
            Medicinal Concoctions: Drinks such as boiled Garlic water, Mustard
            and Garlic water, and Kollu with Garlic water are also permissible.
          </li>
          <li className="mt-5">
            Drinks made from fresh or dried flowers (excluding Mee flowers) are
            allowed.
          </li>
        </ul>

        <p className="h4 mt-6 ">
          <span className="dark-gold text-bold">&#x2022; Edible Items:</span>{" "}
          Certain sweet and herbal items, without milk or nuts, are permissible
          in the evening. These include:
        </p>
        <ul className="mt-5 list-0 h4">
          <li className="mt-5">
            Sugars and Sweets: Sugar, sugar candies, toffees, treacle, jaggery,
            bees' honey, dark chocolates, gingerly oil, sweet ginger, sweet
            Hathawariya legume, and both sweet and non-sweet ginger pieces.
          </li>
          <li className="mt-5">
            Garlic Preparations: Fresh, boiled, roasted, or fried garlic pieces,
            or garlic fried in butter or ghee, are acceptable. Garlic fermented
            in honey is also allowed.
          </li>
          <li className="mt-5">
            Nelli Fruits: Fresh or dried Nelli fruits, or Nelli fruits fermented
            in honey, are considered medicinal and are permissible.
          </li>
          <li className="mt-5">
            Dairy Items: Butter and ghee can be consumed.
          </li>
          <li className="mt-5">
            Coriander Preparation: A boiled coriander powder and honey mixture
            is also allowed.
          </li>
        </ul>
      </div>

      <img src={imageFour} alt="" className="mt-6" style={{ width: "100%" }} />


      <div className="p-4 mt-5">
      <p className="h4 mt-6 ">
          <span className="dark-gold text-bold">Chatu Madura:</span>{" "}
          The Four Delicacies
        </p>

        <p className="mt-4 h4 ">The Buddha recommended the consumption of Chatu Madura, which translates to "the four delicacies" — a mixture of ghee, jaggery, bees' honey, and butter. This nourishment is allowed at any time and holds significant Ayurvedic properties:</p>
        <p className="mt-4 h4 ">
          1. Bee Honey: An all-purpose remedy for various ailments, particularly for digestion, energy, and immune function.
        </p>
        <p className="mt-4 h4 ">
          2. Ghee: Known for promoting longevity, soothing the voice, and supporting overall well-being.
        </p>
        <p className="mt-4 h4 ">
          3. Jaggery: A healthier substitute for sugar, rich in iron and essential minerals, and known to aid digestion and provide energy.
        </p>
        <p className="mt-4 h4 ">
          4. Butter: Offers nourishment, strengthens bones, and improves digestive health.
         
        </p>

        <ul className="mt-5 list-0 h4">
            <li>Substitute: Instead of ghee, sesame oil can be used.</li>
        </ul>
        


        <p className="h4 mt-6 ">
          <span className="dark-gold text-bold">Recipe of Chatu Madura</span>{" "}
          
        </p>

        <p className="mt-4 h4 ">Preparation</p>
        <p className="mt-4 h4 ">
          1. Collect equal quantities of each ingredient.
        </p>
        <p className="mt-4 h4 ">
          2. Chop the butter into small pieces and grate the jaggery.
        </p>
        <p className="mt-4 h4 ">
          3. Heat the butter, and then add the ghee.
        </p>
        <p className="mt-4 h4 ">
          4. Sprinkle water on the jaggery and heat it separately until it melts and boils.
         
        </p>
        <p className="mt-4 h4 ">
          5. Once the jaggery has melted, add the ghee and butter.
         
        </p>
        <p className="mt-4 h4 ">
          6. As the mixture thickens, remove it from the heat and stir well.
         
        </p>
        <p className="mt-4 h4 ">
          7. Once it has cooled, add the honey.
         
        </p>


        <p className="mt-6 h4">The resulting mixture should have a color similar to that of jaggery and will keep for about a week. The best Chatu Madura should have a balanced taste, with no single ingredient dominating. Each ingredient is believed to have numerous health benefits, making it cherished nourishment in the Buddhist monastic tradition.</p>
       <p className="h4 mt-5">While the recipe seems simple, perfecting it requires experience and careful attention.</p>
        <div className="bottom-box mt-5">
          <img src={imageThree} alt="bottom-image" width={600} />
        </div>
      </div>
    </div>
  );
};

export default AfternoonGilapasa;
